import {
  Component,
  Input,
  SimpleChanges,
  OnChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import {Member, AChatroom} from '../../class/ana-chatroom';
import { ChatroomProvider } from '../../providers/chatroom/chatroom';
import {NavController, AlertController, Platform} from 'ionic-angular/index';
import { HttpProvider } from '../../providers/http/http';
import {global} from "../../environments/global";
import {BaseConfigProvider} from "../../providers/base-config/base-config";
import {UtilProvider} from "../../providers/util/util";
import {TimeFormatPipe} from "../../pipes/time-format/time-format";
// import {BaseConfigProvider} from "../../providers/base-config/base-config";
// import {BaseConfigProvider} from "../../providers/base-config/base-config";
// declare var _hmt:any;
/**
 * Generated class for the ChatroomContactComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'chatroom-contact',
  templateUrl: 'chatroom-contact.html',
  host: { '(document:click)': 'hideShowBox($event)' },
})
export class ChatroomContactComponent implements OnChanges {
  @Input() chatroom: AChatroom;

  @Input() time_scope: number;
  @Output() change_time_scope = new EventEmitter();
  @Output() showMember = new EventEmitter();

  // @ViewChild('dropDown') drop_down:ElementRef;

  ngOnChanges(change: SimpleChanges) {
    // if()
    if (change['chatroom'] && this.chatroom) {
      // _hmt.push(['_trackPageview', '/ChatroomContact']);

      this.choosed_scope = this.scopes[this.time_scope];
      // this.input_value = (this.chatroom[this.sorts[Math.abs(this.sort_type) -1].value]);
      // this.getChatroomInfo();
      this.initMemberList();
    }
  }

  hideShowBox(e) {
    this.show_box_index = null;
  }

  scopes = [
    { name: '今日', value: 1 },
    {name:'昨天',value:2},
    { name: '7天', value: 3 },
    { name: '30天', value: 4 },
    // { name: '全部', value: 5 },
  ];

  choosed_scope;

  changeScope(index) {
      this.choosed_scope = this.scopes[index];
      this.change_time_scope.emit(index);
      this.initMemberList();

  }

  // sorts = [
  //   {name:'影响力',value:''},
  //
  // ];

  // sorts = BaseConfigProvider.sort_string;
  sorts = [
    // { name: '影响力', value: 'effect_count', func: 'effect_' },
    { name: '发言数', value: 'speak_count', func: 'speak_' },
    { name: '拉新数', value: 'invitation_count', func: 'invitation_' },
    { name: '被@数', value: 'be_at_count', func: 'be_at_' },
  ];

  show_box_index;
  showBox(e, index) {
    e.stopPropagation();
    this.show_box_index = index;
  }

  constructor(
    private chatroomService: ChatroomProvider,
    public navCtrl: NavController,
    public http: HttpProvider,
    public plt:Platform,
    public util:UtilProvider,
    public alertCtrl: AlertController
  ) {
    this.sort_type = this.sorts[0];
    this.choosed_sort = 1;
    this.page = 0;
    this.pagesize = 500;
  }

  sort_type;
  page: number;
  pagesize: number;
  input_value;
  choosed_sort;
  is_desc: boolean;
  changeSort(type) {
    //  TODO: type 的绝对值表示排序类型,正负表示正序或者倒序
    if (type.value != this.sort_type.value) {
      this.sort_type = type;
      this.is_desc = false;

    }
    else {
      this.is_desc = !this.is_desc;
    }
    this.initMemberList();

    // this.choosed_sort = Math.abs(this.sort_type);
    // this.input_value = (this.chatroom[this.sorts[Math.abs(this.sort_type) -1].value]);
  }

  resort() {
    //TODO:昶子菜,让我注释的
    // this.sort_type = -this.sort_type;
    // this.initMemberList();
    this.is_desc = !this.is_desc;
    this.initMemberList();
  }

  update_time;
  initMemberList() {
    this.is_error_loading = false;
    this.is_loading_member = false;
    this.have_next_page = true;
    this.member_list = [];
    this.page = 1;
    // this.updata_time = new Date().getTime();
    if (this.ob_getMemberList) {
      this.ob_getMemberList.unsubscribe();
    }

    this.getMemberList();
    // th
  }

  // ob_getChatroomInfo;
  // is_loading_chatroom;
  // getChatroomInfo(){
  //   this.is_loading_chatroom = true;
  //   this.ob_getChatroomInfo = this.chatroomService.getChatroomInfo(this.chatroom.chatroom_id,this.choosed_scope.value).subscribe(res => {
  //     this.is_loading_chatroom = false;
  //     this.chatroom = new Chatroom(res['content']['chatroom']);
  //   },err => {
  //     this.is_loading_chatroom = false;
  //   })
  // }

  member_list: Array<Member>;
  is_loading_member: boolean;
  have_next_page: boolean;
  is_error_loading: boolean;
  ob_getMemberList;
  self_info: Member;
  self_index: number;
  owner_id: number;
  getMemberList() {
    this.is_error_loading = false;
    this.is_loading_member = true;
    this.ob_getMemberList = this.chatroomService
      .getMemberList(
        this.chatroom.chatroomname,
        this.choosed_scope.value,
        this.sort_type.func + (this.is_desc ? 'asc': 'desc'),
        this.page,
        this.pagesize
      )
      .subscribe(
        res => {
          this.is_error_loading = false;
          this.is_loading_member = false;
          if (res['content']['member_list'].length < this.pagesize) {
            this.have_next_page = false;
          }
          this.member_list = this.member_list.concat(
            res['content']['member_list'].map(item => new Member(item))
          );
          this.update_time = res['content']['last_update_time'];
          this.self_info = res['content']['self_member']
            ? new Member(res['content']['self_member'])
            : null;
          this.self_index = res['content']['self_index'];
          this.owner_id = res['content']['owner_id'];
        },
        err => {
          this.is_loading_member = false;
          this.is_error_loading = true;
          // this.http.errCatch(err);
        }
      );
  }

  is_bottom: boolean;
  loadMore(e) {
    // var el = e.target;
    // if (el.scrollTop + el.clientHeight > el.scrollHeight - 1) {
    //   this.is_bottom = true;
    // }
    // if (
    //   el.scrollTop + el.clientHeight > el.scrollHeight - 1 &&
    //   !this.is_loading_member &&
    //   this.have_next_page
    // ) {
    //   this.page++;
    //   this.getMemberList();
    // }
  }

  showContact(member: Member) {

      this.showMember.emit(member.username);
      // this.util.myNav(this.navCtrl,'ContactPage',{
      //   chatroom: this.chatroom.chatroomname,
      //   member: member.username,
      // });

  }

  applyChatroomOwner() {
    this.chatroomService
      .applyChatroomOwner(this.chatroom.chatroomname)
      .subscribe(
        res => {
          let alert = this.alertCtrl.create({
            title: '群主申请已发送',
            message:
              '群主申请已发送,请稍等查看处理结果。如果想加快进度,可联系客服处理。',
            buttons: [
              {
                text: '知道了',
              },
            ],
          });
          alert.present();
        },
        err => {

        }
      );
  }

  changeToImg() {
    // console.log(this.member_list.slice(0,10));
    this.navCtrl.push('ChangeImgPage', {
      chatroom: JSON.stringify(this.chatroom),
      scope: this.choosed_scope.value,
      order: this.sort_type.func,
      member_list: JSON.stringify(this.member_list.slice(0, 10)),
    });
  }

  haveShareData() {
    return (
      this.member_list &&
      this.member_list.filter(item => item[this.sort_type.value] > 0).length > 0
    );
  }

  download(){
    console.log(this._startDate);
      let url = global.base_url + global.env_url + '/group/statistics_member_excel?token='+
        localStorage.getItem(global.token_name) +
        '&order='+this.sort_type.func + (this.is_desc ? 'asc': 'desc') +
        '&chatroomname='+ this.chatroom.chatroomname +
        '&date_start='+ (new Date(this._startDate).getTime()/1000) +
        '&date_end=' + (new Date(this._endDate).getTime()/1000 )+
        '&get_excel=1';
      // console.log(url);
      // let elemIF = document.createElement("iframe");
      // // this.timeFilterValue, this.order, this.page, this.pagesize,this.groupFilterValue,this.chatroomActiveIndex
      // elemIF.src = url;
      // elemIF.style.display = "none";
      // document.body.appendChild(elemIF);
      window.open(url);
    this.showExport = false;

  }


  _startDate = new TimeFormatPipe().transform(Date.now(),'yyyy-MM-dd');
  _endDate = new TimeFormatPipe().transform(Date.now(),'yyyy-MM-dd');
  minEndDate;
  maxEndDate;
  minStartDate;
  maxStartDate;
  showExport;

  changeTime(){
    let maxTime = Date.now();
    let minTime = (Date.now() - 90*24*60*60*1000);

    this.maxEndDate = this.util.getISODate(
      UtilProvider.DATE_CURRENT,
      new Date(maxTime)
    );
    this.minStartDate = this.util.getISODate(
      UtilProvider.DATE_CURRENT,
      new Date(minTime)
    );
    this.maxStartDate = this._endDate?this._endDate:new TimeFormatPipe().transform(Date.now(),'yyyy-MM-dd');
    this.minEndDate = this._startDate ?this._startDate: new TimeFormatPipe().transform((Date.now() - 90*24*60*60*1000),'yyyy-MM-dd');
  }
}



// WEBPACK FOOTER //
// ./src/components/chatroom-contact/chatroom-contact.ts